import React, { useState, useEffect } from "react";
import { Zap, Menu, X } from "lucide-react";
import { typeformLinkProps } from "./TypeformModal";

const LINKS = [
    { label: "Pillars", href: "#pillars" },
    { label: "Results", href: "#results" },
    { label: "FAQ", href: "#faq" },
];

const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="navbar"
            className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color] duration-300 ${
                scrolled ? "glass-panel border-b border-neon-purple/15" : "bg-transparent"
            }`}
        >
            <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
                <a href="#top" data-testid="nav-logo" className="flex items-center gap-2.5">
                    <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-neon-purple to-neon-pink glow-purple">
                        <Zap className="h-4.5 w-4.5 text-white" size={18} />
                    </span>
                    <span className="font-display text-sm font-bold tracking-widest text-white">
                        FAN<span className="text-gradient-neon">CREATOR</span>
                    </span>
                </a>

                <nav className="hidden items-center gap-8 md:flex">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className="font-mono-tech text-xs uppercase tracking-[0.2em] text-white/60 transition-colors duration-200 hover:text-neon-blue"
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        {...typeformLinkProps}
                        data-testid="nav-cta-button"
                        className="rounded-full bg-gradient-to-r from-neon-purple to-neon-pink px-5 py-2 text-sm font-bold text-white transition-transform duration-200 hover:scale-105 glow-pink"
                    >
                        Start Now
                    </a>
                </nav>

                <button
                    data-testid="nav-mobile-toggle"
                    className="text-white md:hidden"
                    onClick={() => setOpen(!open)}
                    aria-label="Toggle menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {open && (
                <div className="glass-panel border-t border-neon-purple/15 px-5 py-4 md:hidden" data-testid="nav-mobile-menu">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            onClick={() => setOpen(false)}
                            className="block py-2.5 font-mono-tech text-xs uppercase tracking-[0.2em] text-white/70"
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        {...typeformLinkProps}
                        className="mt-2 block rounded-full bg-gradient-to-r from-neon-purple to-neon-pink px-5 py-2.5 text-center text-sm font-bold text-white"
                    >
                        Start Now
                    </a>
                </div>
            )}
        </header>
    );
};

export default Navbar;
